import { Menu as MuiMenu, MenuProps as MuiMenuProps } from '@mui/material';

type Props = Pick<
  MuiMenuProps,
  | 'action'
  | 'anchorEl'
  | 'open'
  | 'onClose'
  | 'anchorOrigin'
  | 'transformOrigin'
  | 'marginThreshold'
  | 'children'
  | 'keepMounted'
  | 'elevation'
  | 'className'
  | 'slotProps'
  | 'sx'
  | 'disableAutoFocusItem'
  | 'onMouseEnter'
  | 'onMouseLeave'
> & {
  testId?: string;
  isHoverSubmenu?: boolean;
};

const HOVER_SUBMENU_SX = {
  pointerEvents: 'none',
  '& .MuiMenu-paper': { pointerEvents: 'auto' },
};

const Menu = ({
  action,
  anchorEl,
  open,
  onClose,
  anchorOrigin,
  transformOrigin,
  marginThreshold,
  children,
  keepMounted,
  elevation,
  className,
  slotProps,
  sx,
  disableAutoFocusItem,
  isHoverSubmenu,
  testId,
  onMouseEnter,
  onMouseLeave,
}: Props) => {
  const paperSlotProps = typeof slotProps?.paper === 'function' ? undefined : slotProps?.paper;

  const resolvedSx = [
    ...(isHoverSubmenu ? [HOVER_SUBMENU_SX] : []),
    ...(Array.isArray(sx) ? sx : [sx]),
  ];

  const resolvedSlotProps = {
    ...slotProps,
    paper: {
      ...paperSlotProps,
      onMouseEnter: onMouseEnter ?? paperSlotProps?.onMouseEnter,
      onMouseLeave: onMouseLeave ?? paperSlotProps?.onMouseLeave,
    },
  };

  return (
    <MuiMenu
      action={action}
      anchorEl={anchorEl}
      open={open}
      onClose={onClose}
      anchorOrigin={anchorOrigin}
      transformOrigin={transformOrigin}
      marginThreshold={marginThreshold}
      keepMounted={keepMounted}
      elevation={elevation}
      className={className}
      disableAutoFocusItem={disableAutoFocusItem}
      test-id={testId}
      sx={resolvedSx}
      slotProps={resolvedSlotProps}
    >
      {children}
    </MuiMenu>
  );
};

export type { Props as MenuProps };
export default Menu;
